import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { PostNewsRequestModel, PostNewsResponseModel } from "@/features/news/services/post-news-model";

export class PostNewsApi {
  /**
   * お知らせ既読情報登録API
   */
  public postNews = async (
    param: PostNewsRequestModel
  ): Promise<PostNewsResponseModel> => {
    const path = `/api/noticeinfo`;

    const res = await ApiClient.instance.post<PostNewsResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
